import React from "react";

const RateList = ({ isModalOpen, onClose, itemsRate }) => {
  if (!isModalOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-white rounded shadow-lg p-6 w-[750px]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg text-center font-bold mb-2 border-b pb-2">
          Rate List
        </h2>

        <div className="max-h-[500px] overflow-y-auto">
          <table className="table-auto w-full border border-gray-300">
            <thead className="bg-blue-100 sticky top-0 z-10">
              <tr>
                <th className="border px-4 py-2 text-left">Sno</th>
                <th className="border px-4 py-2 text-left">Date</th>
                <th className="border px-4 py-2 text-left">Party Name</th>
                <th className="border px-4 py-2 text-left">Rate</th>
              </tr>
            </thead>
            <tbody>
              {itemsRate.length === 0 ? (
    <tr>
      <td
        colSpan={4}
        className="border px-4 py-4 text-center text-gray-500 italic"
      >
        Not Found Previous Rate list
      </td>
    </tr>
  ) :
             ( itemsRate.map((item, index) => (
                <tr key={index} className="hover:bg-red-50">
                  <td className="border px-4 py-2">{index + 1}</td>
                  <td className="border px-4 py-2">
                    {new Intl.DateTimeFormat("en-GB").format(
                      new Date(item.purchase_added_on)
                    )}
                  </td>
                  <td className="border px-4 py-2">{item.party_name}</td>
                  <td className="border px-4 py-2">{item.rate}</td>
                </tr>
              )))
            }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RateList;
